<div class="mainheading">
  <h2 class="text-white">
    {{
      window.globalActiveUser ? (
        window.globalActiveUser.isSelectedOrganisationAccount?.name ||
        (window.globalActiveUser.organisationAccount ? window.globalActiveUser.organisationAccount.name : null) ||
        (window.globalActiveUser.firstName + ' ' + window.globalActiveUser.lastName)
      ) : ''
    }}
  </h2>
</div>
<div class="card">
  <div class="card-header">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="mb-0">{{ 'Organization Details' | localize }}</h3>
      <button mat-button color="primary">
        <div class="d-flex align-items-center" (click)="goBack()">
          <i-tabler name="arrow-left" class="me-1"></i-tabler>
          <span>{{ 'Organization.Back' | localize }}</span>
        </div>
      </button>
    </div>
  </div>
  <div class="card-body">
    <div *ngIf="isLoading" class="text-center my-4">
      <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
    </div>

    <div *ngIf="error" class="alert alert-danger">
      {{ error }}
    </div>

    <div *ngIf="!isLoading && !error && organization">
      <mat-tab-group #tabGroup [selectedIndex]="selectedTab" (selectedTabChange)="onTabChange($event)">
        <!-- Details Tab -->
        <mat-tab [label]="labels.detailsTab | localize">
          <div class="pt-3">
            <div class="row">
              <div class="col-md-12">
                <mat-card>
                  <mat-card-header>
                    <mat-card-title>{{ labels.basicInfo | localize }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="mt-3">
                      <p><strong>ID:</strong> {{ organization.id }}</p>
                      <p><strong>{{ 'Organization.OrganizationName' | localize }}:</strong> {{ organization.name }}</p>
                      <p><strong>{{ 'Organization.Type' | localize }}:</strong> {{ organization.type }}</p>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab [label]="labels.authorizedUsers | localize" *ngIf="permissionService.hasPermission('VIEW_ORGANISATION_AUTHORIZED_USERS')">
          <div class="pt-3">
            <div class="row">
              <div class="col-md-12">
                <mat-card>
                  <mat-card-header>
                    <mat-card-title>{{ labels.owners | localize }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div *ngIf="organization.owners && organization.owners.length > 0" class="mb-4">
                      <h4 class="mb-3 text-primary">{{ 'Organization.Owners' | localize }}</h4>
                      <div *ngFor="let owner of organization.owners; let last = last" class="mb-2">
                        <p><strong>{{ 'Organization.OrganizationName' | localize }}:</strong> {{ owner.firstName }} {{ owner.lastName }}</p>
                        <p><strong>Email:</strong> {{ owner.email }}</p>
                        <p><strong>{{ 'Phone' | localize }}:</strong> {{ owner.phone }}</p>
                        <mat-divider *ngIf="!last"></mat-divider>
                      </div>
                    </div>

                    <div *ngIf="(!organization.owners || organization.owners.length === 0)" class="text-muted mt-3">
                      {{ labels.noOwners | localize }}
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab [label]="'LLM Settings' | localize" *ngIf="permissionService.hasPermission('LLM_SETTINGS_VIEW')">
          <app-llm-settings
            [selectedOrganisationId]="organizationId" [loadOnInit]="false">
          </app-llm-settings>
        </mat-tab>
        <mat-tab label="{{ 'Prompt Management' | localize }}" *ngIf="permissionService.hasPermission('PROMPT_MANAGEMENT_VIEW')">
          <app-prompt-management
            [selectedOrganisationId]="organizationId"
            [loadOnInit]="false" [organisationComponent]="true">
          </app-prompt-management>
        </mat-tab>
        <mat-tab [label]="'KeyCloak Settings' | localize" *ngIf="permissionService.hasPermission('KEYCLOK_MANAGEMENT_VIEW')">
          <app-keycloak-matching
            [selectedOrganisationId]="organizationId" [loadOnInit]="false">
          </app-keycloak-matching>
        </mat-tab>
        <mat-tab [label]="'Role Management' | localize" *ngIf="permissionService.hasPermission('KEYCLOK_MANAGEMENT_VIEW')">
          <app-role-management [selectedOrganisationId]="organizationId"></app-role-management>
        </mat-tab>
        <mat-tab [label]="'Resource Management' | localize" *ngIf="permissionService.hasPermission('KEYCLOK_MANAGEMENT_VIEW')">
          <app-resource-management [selectedOrganisationId]="organizationId"></app-resource-management>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div *ngIf="!isLoading && !error && !organization" class="text-center my-4">
      {{ 'Organization not found' | localize }}
    </div>
  </div>
</div>
